var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7331 2.73333V4.2C13.7331 4.73334 13.3998 5.4 13.0664 5.73334L10.1998 8.26667C9.79976 8.6 9.53309 9.26667 9.53309 9.8V12.6667C9.53309 13.0667 9.26643 13.6 8.93309 13.8L7.99976 14.4C7.13309 14.9333 5.93309 14.3333 5.93309 13.2667V9.73334C5.93309 9.26667 5.66643 8.66667 5.39976 8.33333L5.08643 8.00667C4.87976 7.78667 4.83976 7.45334 5.00643 7.19334L8.41976 1.71333C8.53976 1.52 8.75309 1.4 8.98643 1.4H12.3998C13.1331 1.4 13.7331 2 13.7331 2.73333Z",
    fill: "#4282E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89994 2.42L4.53327 6.21334C4.3066 6.58 3.7866 6.63333 3.4866 6.32L2.8666 5.66667C2.53327 5.33333 2.2666 4.73334 2.2666 4.33333V2.8C2.2666 2 2.8666 1.4 3.59993 1.4H6.33327C6.85327 1.4 7.17327 1.97334 6.89994 2.42Z",
    fill: "#4282E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterActive);
export default __webpack_public_path__ + "static/media/filter-active.d76bc306dcfdc9f687d9072ba1adcc6e.svg";
export { ForwardRef as ReactComponent };